<template>
    <div class="content_mini_info right_on_mob">
        <div class="mini_info box_shadow flex">
            <div class="image_part">
                <div class="image">
                    <picture
                        v-full-image-path:assets="'icon_event_schedule.svg'"
                    />
                </div>
            </div>
            <div class="content_part">
                <div class="content">
                    <h2>{{ value.title }}</h2>
                    <div v-html="value.text" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
